export default "__VITE_ASSET__q$U5eR7E__"